import {useContext} from 'react';
import {Context as BridgeContext} from '../contexts/BridgeContext';

export const useBridge = () => useContext(BridgeContext);
